// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class DocumentUploadResponseModel {
    static getAttributeTypeMap() {
        return DocumentUploadResponseModel.attributeTypeMap;
    }
}
DocumentUploadResponseModel.discriminator = undefined;
DocumentUploadResponseModel.additionalProperties = false;
DocumentUploadResponseModel.attributeTypeMap = [
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
];
//# sourceMappingURL=documentUploadResponseModel.js.map